/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../request'

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig
}

const mockUrl_0_0_0_41 = 'http://127.0.0.1:50505/mock/0' as any
const devUrl_0_0_0_41 = '' as any
const prodUrl_0_0_0_41 = '' as any
const dataKey_0_0_0_41 = 'data' as any

/**
 * 接口 根据新品属性ID删除订单 的 **请求类型**
 *
 * @分类 new-product-property-controller
 * @请求头 `POST /newProductProperty/delNewProductPropertyById`
 */
export interface DelNewProductPropertyByIdRequest {
  /**
   * ids
   */
  new_product_property_id?: number[]
}

/**
 * 接口 根据新品属性ID删除订单 的 **返回类型**
 *
 * @分类 new-product-property-controller
 * @请求头 `POST /newProductProperty/delNewProductPropertyById`
 */
export interface DelNewProductPropertyByIdResponse {
  code?: number
  errorInfo?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  isAuthorizedRequest?: boolean
  /**
   * 是否返回正确结果
   */
  isSuccess?: boolean
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: string
  /**
   * 报错接口URI
   */
  targetUrl?: string
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 根据新品属性ID删除订单 的 **请求配置的类型**
 *
 * @分类 new-product-property-controller
 * @请求头 `POST /newProductProperty/delNewProductPropertyById`
 */
type DelNewProductPropertyByIdRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProductProperty/delNewProductPropertyById',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 根据新品属性ID删除订单 的 **请求配置**
 *
 * @分类 new-product-property-controller
 * @请求头 `POST /newProductProperty/delNewProductPropertyById`
 */
const delNewProductPropertyByIdRequestConfig: DelNewProductPropertyByIdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_41,
  devUrl: devUrl_0_0_0_41,
  prodUrl: prodUrl_0_0_0_41,
  path: '/newProductProperty/delNewProductPropertyById',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_41,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'delNewProductPropertyById',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 根据新品属性ID删除订单 的 **请求函数**
 *
 * @分类 new-product-property-controller
 * @请求头 `POST /newProductProperty/delNewProductPropertyById`
 */
export const delNewProductPropertyById = /*#__PURE__*/ (
  requestData: DelNewProductPropertyByIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<DelNewProductPropertyByIdResponse>(
    prepare(delNewProductPropertyByIdRequestConfig, requestData),
    ...args,
  )
}

delNewProductPropertyById.requestConfig = delNewProductPropertyByIdRequestConfig

/**
 * 接口 根据新品id获取新品属性 的 **请求类型**
 *
 * @分类 new-product-property-controller
 * @请求头 `GET /newProductProperty/getNewProductPropertyByNewProductId`
 */
export interface GetNewProductPropertyByNewProductIdRequest {
  /**
   * new_product_id
   */
  new_product_id: string
}

/**
 * 接口 根据新品id获取新品属性 的 **返回类型**
 *
 * @分类 new-product-property-controller
 * @请求头 `GET /newProductProperty/getNewProductPropertyByNewProductId`
 */
export interface GetNewProductPropertyByNewProductIdResponse {
  /**
   * 状态码
   */
  code?: number
  error_info?: {
    /**
     * 错误码
     */
    code?: number
    /**
     * 错误堆栈
     */
    details?: string[]
    /**
     * 错误信息
     */
    msg?: string
    validationErrorInfo?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
    validation_error_info?: {
      /**
       * 错误字段
       */
      members?: string[]
      /**
       * 校验详情
       */
      message?: string
    }
  }
  /**
   * 是否有调用权限
   */
  is_authorized_request?: boolean
  /**
   * 是否返回正确结果
   */
  is_success?: boolean
  /**
   * 正确结果
   */
  result?: {
    /**
     * 到货/生产天数
     */
    arrival_days?: number
    /**
     * 最短边
     */
    box_high?: number
    /**
     * 最长边
     */
    box_length?: number
    /**
     * 次长边
     */
    box_width?: number
    /**
     * 新品属性ID
     */
    id?: number
    /**
     * 属性图片
     */
    image_list?: {
      default?: boolean
      id?: number
      is_default?: boolean
      picture_url?: string
    }[]
    /**
     * 最小订货量
     */
    min_num?: number
    /**
     * 新品ID
     */
    new_product_id?: number
    /**
     * 新品属性编号
     */
    new_product_property?: string
    /**
     * POA颜色
     */
    poa_color?: string
    /**
     * POA尺码/其他
     */
    poa_size?: string
    /**
     * POA尺码类型
     */
    poa_size_type?: number
    /**
     * 价格（元）
     */
    price?: number
    /**
     * 审核时间
     */
    review_date?: string
    review_remark?: string
    /**
     * 状态(0：草稿，1：待采用，2：已采用，3：取消采用)
     */
    status?: number
    /**
     * 供应商ID
     */
    supplier_id?: number
    /**
     * 特性标注
     */
    thirdparty_feature_callout?: {}[]
    /**
     * 特性标签id
     */
    thirdparty_feature_callout_id?: number[]
    /**
     * 第三方ID
     */
    thirdparty_id?: number
    /**
     * 第三方新品poa
     */
    thirdparty_product_property_code?: string
    /**
     * 重量（g）
     */
    weight?: number
  }[]
  /**
   * 报错接口URI
   */
  target_url?: string
}

/**
 * 接口 根据新品id获取新品属性 的 **请求配置的类型**
 *
 * @分类 new-product-property-controller
 * @请求头 `GET /newProductProperty/getNewProductPropertyByNewProductId`
 */
type GetNewProductPropertyByNewProductIdRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/newProductProperty/getNewProductPropertyByNewProductId',
    'data',
    string,
    'new_product_id',
    false
  >
>

/**
 * 接口 根据新品id获取新品属性 的 **请求配置**
 *
 * @分类 new-product-property-controller
 * @请求头 `GET /newProductProperty/getNewProductPropertyByNewProductId`
 */
const getNewProductPropertyByNewProductIdRequestConfig: GetNewProductPropertyByNewProductIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_41,
    devUrl: devUrl_0_0_0_41,
    prodUrl: prodUrl_0_0_0_41,
    path: '/newProductProperty/getNewProductPropertyByNewProductId',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_41,
    paramNames: [],
    queryNames: ['new_product_id'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'getNewProductPropertyByNewProductId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  }

/**
 * 接口 根据新品id获取新品属性 的 **请求函数**
 *
 * @分类 new-product-property-controller
 * @请求头 `GET /newProductProperty/getNewProductPropertyByNewProductId`
 */
export const getNewProductPropertyByNewProductId = /*#__PURE__*/ (
  requestData: GetNewProductPropertyByNewProductIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetNewProductPropertyByNewProductIdResponse>(
    prepare(getNewProductPropertyByNewProductIdRequestConfig, requestData),
    ...args,
  )
}

getNewProductPropertyByNewProductId.requestConfig = getNewProductPropertyByNewProductIdRequestConfig

/* prettier-ignore-end */
